import { useMutation } from '@tanstack/react-query';
import { api } from '@/api/client';
import type { AskAiQueryRequest, AskAiQueryResponse } from '@/types/askAi';

export function useAskAiMutation() {
  return useMutation<AskAiQueryResponse, Error, AskAiQueryRequest>({
    mutationFn: async (req) => {
      const resp = await api.post<AskAiQueryResponse>('/ask-ai/query', req);
      return resp.data;
    },
  });
}
